function imageRowOrSlider() {
	const blocks = document.querySelectorAll(".image-row-or-slider");

	blocks.forEach((block) => {
		const carousel = block.querySelector(".image-row-or-slider__carousel");
		const prev = block.querySelector(".image-row-or-slider__control--prev");
		const next = block.querySelector(".image-row-or-slider__control--next");
		const desktopStatic = block.classList.contains(
			"image-row-or-slider--desktop-static",
		);
		const desktopQuery = window.matchMedia("(min-width: 64em)");
		let swiper = null;

		const update = () => {
			const useStaticLayout = desktopStatic && desktopQuery.matches;

			if (useStaticLayout) {
				if (swiper) {
					swiper.destroy(true, true);
					swiper = null;
				}
				return;
			}

			if (swiper || typeof Swiper === "undefined") {
				return;
			}

			swiper = new Swiper(carousel, {
				slidesPerView: "auto",
				spaceBetween: 10,
				watchOverflow: true,
				grabCursor: true,
				centeredSlides: false,
				slidesOffsetBefore: 20,
				slidesOffsetAfter: 20,
				breakpoints: {
					768: {
						spaceBetween: 20,
						slidesOffsetBefore: 32,
						slidesOffsetAfter: 32,
						centeredSlides: false,
					},
				},
				navigation: {
					nextEl: next,
					prevEl: prev,
				},
			});
		};

		update();
		desktopQuery.addEventListener("change", update);
	});
}

imageRowOrSlider();
